// Core Imports
import React, { useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';

// Assets
import Banner from '../../assets/images/aboutus/about-banner-long.jpeg';
import AboutExp1 from '../../assets/images/aboutus/about-exp-1s.jpeg';
import AboutExp2 from '../../assets/images/aboutus/about-exp-2s.jpeg';
import Mission from '../../assets/images/aboutus/about-mission-1s.jpeg';
import Gavin from '../../assets/images/team/gavin-1s.jpg';
import Dan from '../../assets/images/team/dan-1s.jpeg';
import Emma from '../../assets/images/team/emma-1s.jpg';
import Donato from '../../assets/images/team/donato-1s.jpg';
import Bryan from '../../assets/images/team/bryan-1s.jpeg';
import Fiona from '../../assets/images/team/fiona-1s.png';
import Design from '../../assets/images/des-1.png';

// Components
import { Carousel } from 'react-bootstrap';

const TeamPrint = () => {
  const [open, setOpen] = useState({});

  const toggleOpen = (key) => {
    setOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div>
        <section>
        <Container className='mt-5 pt-5'>
            <div className="text-center">
                <h2>OUR TEAM</h2>
                <h3 className="type-2">Leadership Team</h3>
            </div>
            <Row className="justify-content-md-center">
                <Col md={4} className="team">
                <img src={Gavin} alt="Gavin Chen" className="img-fluid profile" />
                <img src={Design} alt="Decorative Design" className="design" />
                <h4>Gavin Chen</h4>
                <p>Project Manager</p>
                <div className={`collapse ${open.gavin ? "show" : "show"}`}>
                    <p className="desc mt-1 mx-3">
                    I work as a Project Manager, overseeing day-to-day construction activities on site. My role involves making sure works are delivered in line with the programme, coordinating subcontractors, and managing site safety and quality. I deal with issues as they arise, keep the site organised, and maintain clear communication with the project team. Overall, I focus on keeping the site running safely, efficiently, and smoothly.
                    </p>
                </div>
                </Col>

                <Col md={4} className="team">
                <img src={Dan} alt="Dan Lorio" className="img-fluid profile" />
                <img src={Design} alt="Decorative Design" className="design" />
                <h4>Dan Lorio</h4>
                <p>General Manager</p>
                <div className={`collapse ${open.dan ? "show" : "show"}`}>
                    <p className="desc mt-1 mx-3">
                    As a General Manager, Dan oversees the strategic and daily operations of the entire organization. With over a decade of leadership experience in property and construction management, he specializes in design management, planning (consent management), financial oversight, and human resources. He is dedicated to fostering a positive and efficient work environment, ensuring the team is fully equipped to meet project goals.
                    </p>
                </div>
                </Col>

                <Col md={4} className="team">
                <img src={Emma} alt="Emmanuel Esteban" className="img-fluid profile" />
                <img src={Design} alt="Decorative Design" className="design" />
                <h4>Emmanuel Esteban</h4>
                <p>In-house Architect</p>
                <div className={`collapse ${open.emma ? "show" : "show"}`}>
                    <p className="desc mt-1 mx-3">
                    I work as an Architectural Technician/ Designer, supporting the design and delivery of projects from early development through to construction. My role involves producing detailed drawings, coordinating with engineers and contractors, and making sure everything lines up with regulations and buildability. I also help with planning and consent documentation, material selection, and resolving queries as the project progresses on site. Along the way, I assist the Project Manager with design input, site visits, and owner instructions when needed. It’s a hands-on role that blends technical precision with practical problem-solving, keeping projects moving smoothly day to day.
                    </p>
                </div>
                </Col>

                <Col md={4} className="team">
                <img src={Donato} alt="Laurencio Donato" className="img-fluid profile" />
                <img src={Design} alt="Decorative Design" className="design" />
                <h4>Laurencio Donato</h4>
                <p>Earthworks foreman</p>
                <div className={`collapse ${open.donato ? "show" : "show"}`}>
                    <p className="desc mt-1 mx-3">
                    I lead a small, skilled earthworks crew of around eight people, making sure all ground works are done safely, accurately, and on schedule. I plan the daily tasks, coordinate machinery and operators, and keep a close eye on levels, drainage, and site preparation. I work hands-on alongside the team and stay in constant contact with engineers and the wider construction crew. When issues come up, I solve them quickly and practically so work keeps moving. My focus is on setting a calm, professional tone and delivering solid groundwork that everything else depends on.
                    </p>
                </div>
                </Col>

                <Col md={4} className="team">
                <img src={Bryan} alt="Bryan Mariano" className="img-fluid profile" />
                <img src={Design} alt="Decorative Design" className="design" />
                <h4>Bryan Mariano</h4>
                <p>Construction foreman</p>
                <div className={`collapse ${open.bryan ? "show" : "show"}`}>
                    <p className="desc mt-1 mx-3">
                    I oversee the day-to-day construction of the projects, managing a team of around twenty people across multiple trades. I organise people, materials, and workflows to keep the site running safely and efficiently. I set daily priorities, check quality, and make sure the build follows the plans and standards. I work closely with project managers, subcontractors, and inspectors to keep everyone aligned. My role is about leadership on site—keeping the team motivated, productive, and proud of the work we’re building together.
                    </p>
                </div>
                </Col>

                <Col md={4} className="team">
                <img src={Fiona} alt="Fiona McLoughlin" className="img-fluid profile" />
                <img src={Design} alt="Decorative Design" className="design" />
                <h4>Fiona McLoughlin</h4>
                <p>Admin</p>
                <div className={`collapse ${open.fiona ? "show" : "show"}`}>
                    <p className="desc mt-1 mx-3">
                    I help keep day-to-day site operations running smoothly by coordinating with supervisors, workers, suppliers, and transport providers so everything is where it needs to be on time. I manage tools, equipment, and inventory, keeping track of allocations, warranties, and returns to make sure nothing falls through the cracks. I handle procurement and deliveries, placing orders, checking what arrives on site, resolving any issues, and keeping records up to date. I support health and safety by running site inductions, issuing PPE, and making sure everyone understands how things are done. I also assist with recruitment, onboarding, and finance admin, including processing invoices and keeping project documentation organised.
                    </p>
                </div>
                </Col>
            </Row>
        </Container>
        </section>

    </div>
  );
};

export default TeamPrint;
